/* PrimeBuild Premium: animaciones y carrusel de las secciones pbp-* */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.pbp-reveal:not(.pbp-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('pbp-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('pbp-visible'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initParallax() {
    if (reduce) return;
    var items = document.querySelectorAll('[data-pbp-parallax]');
    if (!items.length) return;
    var ticking = false;
    function update() {
      items.forEach(function (el) {
        var k = parseFloat(el.getAttribute('data-pbp-parallax')) || 0;
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        el.style.transform = 'translate3d(0,' + (-r.top * k).toFixed(1) + 'px,0) scale(1.08)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  function initRails(root) {
    (root || document).querySelectorAll('[data-pbp-rail]').forEach(function (rail) {
      var track = rail.querySelector('.pbp-rail__track');
      if (!track) return;
      rail.querySelectorAll('[data-pbp-dir]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var card = track.firstElementChild;
          var step = card ? card.getBoundingClientRect().width + 14 : 300;
          track.scrollBy({ left: step * parseInt(btn.getAttribute('data-pbp-dir'), 10), behavior: 'smooth' });
        });
      });
    });
  }

  function init() { initReveal(); initParallax(); initRails(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); initRails(e.target); });
})();
